import { message, Modal } from "antd";
import React, { useRef, useState, useEffect } from "react";
import QrReader from "react-qr-reader";
import { useDispatch, useSelector } from "react-redux";
import {
  getInfoWarrantyWeb,
  selectError,
} from "../../redux/reducers/slice/warranty";
import "./scanQrStyle.scss";

const ScanQRWarantyModal = (props: any) => {
  const { visible, typeQR, setVisible, setTypeQR } = props;
  const dispatch = useDispatch();
  const qrReader1 = useRef(null);
  const qrReader2 = useRef(null);
  const [error, setError] = useState("");
  const [isUploadAnother, setIsUploadAnother] = useState(false);
  const errorMessage = useSelector(selectError);
  const timeoutRef = useRef<any>(null);

  useEffect(() => {
    if (typeQR === "SCAN" && errorMessage) {
      message.error({
        content: errorMessage,
        style: {
          marginTop: 60,
        },
      });
    }
  }, [errorMessage]);

  const getInfoWarranty = (data: any) => {
    setError("");

    const _data = data;

    const arrSplit = _data.split(" ");
    const id = arrSplit[arrSplit.length - 1];

    dispatch(getInfoWarrantyWeb(id));
  };

  const handleScan = async (data: any) => {
    setIsUploadAnother(true);
    if (data) {
      if (typeQR === "SCAN") {
        if (!timeoutRef.current) {
          timeoutRef.current = setTimeout(() => {
            getInfoWarranty(data);

            timeoutRef.current = null;
          }, 3000);
        }
      } else {
        getInfoWarranty(data);
      }
    }
  };

  const handleError = (err: any) => {
    setError(err?.message);
  };

  const openImageDialog = () => {
    if (qrReader2 && qrReader2.current) {
      qrReader2.current.openImageDialog();
    }
  };

  return (
    <Modal
      width={400}
      title={typeQR === "SCAN" ? "Quét mã QR từ camera" : "Tải mã QR từ máy"}
      visible={visible}
      footer={null}
      onCancel={() => {
        setVisible(false);
      }}>
      <div className="scan-qr">
        {typeQR === "SCAN" ? (
          <>
            <QrReader
              className={`scan-qr__camera`}
              ref={qrReader1}
              delay={0}
              onError={handleError}
              onScan={handleScan}
              style={{
                width: 200,
              }}
            />

            {error && (
              <div className="scan-qr__error">
                <span className="scan-qr__text main-content">
                  Không thể truy cập máy ảnh để quét QR,
                  <br />
                  Vui lòng chọn chức năng{" "}
                  <a onClick={() => setTypeQR("UPLOAD")}>tải mã QR từ máy</a>.
                </span>
              </div>
            )}
          </>
        ) : (
          <>
            <QrReader
              className="scan-qr__upload"
              ref={qrReader2}
              delay={300}
              onError={handleError}
              onScan={handleScan}
              style={{ width: 200 }}
              legacyMode={true}
            />
            {!isUploadAnother ? (
              <button
                className="scan-qr__upload-btn"
                onClick={openImageDialog}></button>
            ) : (
              <input
                className="scan-qr__upload-input"
                type="button"
                value="Tải lên mã QR từ máy"
                // value="+"
                onClick={openImageDialog}
              />
            )}
            {errorMessage && <p className="message">{errorMessage}</p>}
          </>
        )}
      </div>
    </Modal>
  );
};

export default ScanQRWarantyModal;
